export default "__VITE_ASSET__3d1a5eeb__"